var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDropdownIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0834 12.8337H2.91669C1.95019 12.8337 1.16669 12.0502 1.16669 11.0837V1.75033C1.16669 1.42816 1.42786 1.16699 1.75002 1.16699H9.91669C10.2389 1.16699 10.5 1.42816 10.5 1.75033V8.75033H12.8334V11.0837C12.8334 12.0502 12.0499 12.8337 11.0834 12.8337ZM10.5 9.91699V11.0837C10.5 11.4058 10.7612 11.667 11.0834 11.667C11.4055 11.667 11.6667 11.4058 11.6667 11.0837V9.91699H10.5ZM9.33335 11.667V2.33366H2.33335V11.0837C2.33335 11.4058 2.59452 11.667 2.91669 11.667H9.33335ZM3.50002 4.08366H8.16669V5.25033H3.50002V4.08366ZM3.50002 6.41699H8.16669V7.58366H3.50002V6.41699ZM3.50002 8.75033H6.41669V9.91699H3.50002V8.75033Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDropdownIcon04);
export default __webpack_public_path__ + "static/media/user-dropdown-icon--04.78dcd57898eb2e636d5d22106d99694e.svg";
export { ForwardRef as ReactComponent };